var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/calendar-days"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C4.44772 5 4 5.44772 4 6V20C4 20.5523 4.44772 21 5 21H19C19.5523 21 20 20.5523 20 20V6C20 5.44772 19.5523 5 19 5H5ZM2 6C2 4.34315 3.34315 3 5 3H19C20.6569 3 22 4.34315 22 6V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V6Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 1C16.5523 1 17 1.44772 17 2V6C17 6.55228 16.5523 7 16 7C15.4477 7 15 6.55228 15 6V2C15 1.44772 15.4477 1 16 1Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1C8.55228 1 9 1.44772 9 2V6C9 6.55228 8.55228 7 8 7C7.44772 7 7 6.55228 7 6V2C7 1.44772 7.44772 1 8 1Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 9.44772 2.44772 9 3 9H21C21.5523 9 22 9.44772 22 10C22 10.5523 21.5523 11 21 11H3C2.44772 11 2 10.5523 2 10Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C7 13.4477 7.44772 13 8 13H8.01C8.56228 13 9.01 13.4477 9.01 14C9.01 14.5523 8.56228 15 8.01 15H8C7.44772 15 7 14.5523 7 14Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14C11 13.4477 11.4477 13 12 13H12.01C12.5623 13 13.01 13.4477 13.01 14C13.01 14.5523 12.5623 15 12.01 15H12C11.4477 15 11 14.5523 11 14Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 14C15 13.4477 15.4477 13 16 13H16.01C16.5623 13 17.01 13.4477 17.01 14C17.01 14.5523 16.5623 15 16.01 15H16C15.4477 15 15 14.5523 15 14Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 18C7 17.4477 7.44772 17 8 17H8.01C8.56228 17 9.01 17.4477 9.01 18C9.01 18.5523 8.56228 19 8.01 19H8C7.44772 19 7 18.5523 7 18Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18C11 17.4477 11.4477 17 12 17H12.01C12.5623 17 13.01 17.4477 13.01 18C13.01 18.5523 12.5623 19 12.01 19H12C11.4477 19 11 18.5523 11 18Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18C15 17.4477 15.4477 17 16 17H16.01C16.5623 17 17.01 17.4477 17.01 18C17.01 18.5523 16.5623 19 16.01 19H16C15.4477 19 15 18.5523 15 18Z",
    fill: "#171717"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDays);
export default __webpack_public_path__ + "static/media/calendar-days.ccd8b4e4e560347aeb7dbcdfc8fbf908.svg";
export { ForwardRef as ReactComponent };